import itDashboard from './dashboard/dashboard.json'
import itStats from './stats/stats.json'
import itAccreditation from './accreditation/accreditation.json'
import itCms from './cms/cms.json'
import itAuth from './auth/auth.json'
import itCommon from './common/common.json'
import itCompetition from './competition/competition.json'
import itGeneralApplications from './general-applications/general-applications.json'
import itLeague from './league/league.json'
import itMatch from './match/match.json'
import itNotification from './notification/notification.json'
import itOrganization from './organization/organization.json'
import itPhase from './phase/phase.json'
import itRecreation from './recreation/recreation.json'
import itRoles from './roles/roles.json'
import itSeason from './season/season.json'
import itShared from './shared/shared.json'
import itSponsor from './sponsor/sponsor.json'
import itSport from './sport/sport.json'
import itUnit from './unit/unit.json'
import itUser from './user/user.json'
import itUtils from './utils/utils.json'

export const it = {
    dashboard: itDashboard,
    stats: itStats,
    common: itCommon,
    accreditation: itAccreditation,
    notification: itNotification,
    league: itLeague,
    roles: itRoles,
    season: itSeason,
    sponsor: itSponsor,
    unit: itUnit,
    user: itUser,
    organization: itOrganization,
    sport: itSport,
    shared: itShared,
    competition: itCompetition,
    'general-applications': itGeneralApplications,
    utils: itUtils,
    phase: itPhase,
    auth: itAuth,
    match: itMatch,
    recreation: itRecreation,
    cms: itCms,
}
